<template>
  <v-main class="green lighten-4">
    <v-container fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card class="elevation-12">
            <v-toolbar color="green darken-2" dark flat>用户注册</v-toolbar>
            <v-card-text>
              <user-form model="reg" :userData="{}" @submit="reguser"></user-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import userForm from '@/components/userForm'
export default {
  components:{
    userForm
  },
  methods:{
    reguser(userInfo){
      this.$api
        .register(userInfo)
        .then((res) => {
          this.$store.commit("setuserInfo", res.data);
          this.$store.commit('setsnack', {message:'用户注册成功,3秒后自动跳转到首页！',color:'success'})
          setTimeout(()=>{
            this.$router.push("index");
          },3000)
        })
        .catch((error) => {
          this.$store.commit('setsnack', {message:'用户注册失败！'})
          console.error(error);
        });
    }
  }
};
</script>